import { render, staticRenderFns } from "./CurrentTicket.vue?vue&type=template&id=638d5fde&"
import script from "./CurrentTicket.vue?vue&type=script&lang=js&"
export * from "./CurrentTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports